import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron--down",
  "use": "icon-chevron--down-usage",
  "viewBox": "0 0 8 6",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 6\" id=\"icon-chevron--down\"><path d=\"M4.386 5.532a.5.5 0 0 1-.772 0L.344 1.568A.5.5 0 0 1 .73.75h6.54a.5.5 0 0 1 .385.818l-3.27 3.964Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol